import React, { useEffect, useState } from "react";
import { useAuth } from "../auth/FirebaseAuth.js";
import { useNavigate } from "react-router-dom";
import { getUserById } from "../models/UserFunctions.js";
import { getOrgById, getOrgByRef } from "../models/OrgFunctions.js";
import Row from "../layout/Row.js";
import Column from "../layout/Column.js";
import Divider from "../layout/Divider.js";
import Space from "../layout/Space.js";
import MLTFGPT2 from "../textfields/MLTFGPT2.js";
import DropDown1 from "../dropdowns/DropDown1.js";
import CheckBoxGrey from "../textfields/CheckBoxGrey.js";
import PrimaryButton from "../buttons/PrimaryButton.js";
import createNewClient from "../api/create/createNewClient.js";
import { useSnackbar } from "notistack";
import SmallSpinner from "../loading/SmallSpinner.js";
import { Skeleton, Switch } from "@mui/material";
import { useAppContext } from "../config/AppContext.js";
import {
  getArrayDocDataByRef,
  getDocDataById,
  getDocDataByRef,
  getOrgDataById,
  queryCollection,
  updateDocDataField,
} from "../models/DataFunctions.js";
import Modal1 from "../modals/Modal1.js";
import { set } from "date-fns";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken.js";
import SecondaryButton from "../buttons/SecondaryButton.js";
import sendInvite from "../api/send/sendInvite.js";

import Icon1 from "../icons/Icon.js";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi.js";
import DropDownGPT0 from "../dropdowns/DropDownGTP0.js";
import checkPageAccess, { checkPageAccessV2 } from "../auth/checkPageAccess.js";
import createDocApi from "../api/database/createDocApi.js";
import TextField2AC from "../textfields/TextField2AC.js";
import TextField2 from "../textfields/TextField2.js";
import TextField2T from "../textfields/TextField2T.js";
import DropDownGPT03 from "../dropdowns/DropDownGTP03.js";
import Gleap from "gleap";
import { ToggleSettingsBrick } from "../textfields/EasySwitch.js";
import createNewPartner from "../api/create/createNewPartner.js";
import DropDownGPTS3 from "../dropdowns/DropDownGPTS3.js";
import { fetchPostalCodesApi } from "../api/google_places/GooglePlacesApi.js";
import { checkAndSendTriggerEvent } from "../config/TriggerEmailSystem.js";

function NewPartner({ userData, orgData, navigateWorkspace, workspaceData }) {
  const { currentUser, loading } = useAuth();
  const [partner_exists, setParnterExists] = useState(false);
  const [partner_open, setPartnerOpen] = useState(false);
  const type_options = [
    { value: "constructor", label: "Constructeur" },
    { value: "promotor", label: "Promoteur" },
    {
      label: "Artisans",
      id: "artisan",
    },
    { value: "architect", label: "Architecte" },
    { value: "prospect", label: "Prospect" },

    { value: "mdo", label: "Maître d'oeuvre" },
    { value: "drawer", label: "Dessinateur" },
    { value: "expert", label: "Bureau d'étude" },
    { value: "infiltro", label: "Infiltromètre" },
    { value: "travaux", label: "Entreprise de travaux" },
    { value: "agence_immobilier", label: "Agence immobilière" },
    { value: "mar", label: "MAR" },
    { value: "other", label: "Autre" },
  ];

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const handleCheckEmailExists = async (email) => {
    setPartnerOpen(false);
    setParnterExists(null);

    if (email === "william.bresso@gmail.com") {
      setPartnerOpen(false);
      setParnterExists(null);

      setEmail("");
      handleClickVariant("Vous ne pouvez pas ajouter ce partenaire", "error");
      return;
    }

    if (email.length < 5) {
      return;
    }
    if (!email.includes("@") || !email.includes(".")) {
      setPartnerOpen(false);
      setParnterExists(null);
      return;
    }
    const filters = [
      {
        field: "email",
        operator: "==",
        value: email,
      },
    ];
    const existingUsers = (await queryCollection("user", filters)) || [];
    if (existingUsers.length > 0) {
      let org = await getOrgDataById(existingUsers[0].org_id);
      if (org === orgData) {
        handleClickVariant(
          "Cet email est déjà utilisé par un des membres de votre organisation",
          "error"
        );
        setEmail("");
        setPartnerOpen(false);
        return;
      }

      // check if the org is already in the network
      if (org.masters_id && org.masters_id.includes(orgData.id)) {
        handleClickVariant(
          "Vous avez déjà ce partenaire dans votre réseau",
          "error"
        );
        setEmail("");
        setPartnerOpen(false);
        return;
      }
      setParnterExists(org);
      setPartnerOpen(true);
    }
  };

  // State variables to store the input values
  const [clientType, setClientType] = useState(null);
  const [clientType_2, setClientType2] = useState(null);
  const [entreprise, setEntreprise] = useState("");
  const [prenom, setPrenom] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [ville, setVille] = useState("");
  const [postal, setPostal] = useState("");
  const [adresse, setAdresse] = useState("");
  const [payment_allowed, setPaymentAllowed] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [partner_type, setPartnerType] = useState(null);
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [siren, setSiren] = useState("");
  const [contacts, setContacts] = useState([]);
  const [infos_categories_open, setInfosCategoriesOpen] = useState(false);
  // Fetch user, org, clients, and article data
  const handleFetchData = async () => {
    if (currentUser) {
      try {
        // Fetch user data
        if (
          (await checkPageAccessV2(
            userData,
            orgData,
            workspaceData,
            "basic"
          )) == false
        ) {
          navigateWorkspace("/home");
        }

        // Fetch organization data using user's org reference
        let contact_filters = [
          {
            field: "org_id",
            operator: "==",
            value: orgData.id,
          },
        ];
        const contacts =
          (await queryCollection("contact", contact_filters)) || [];
        // const contacts = org.infiltrea?.contacts || [];
        setContacts(contacts);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  function checkEmail(email) {
    if (email.length < 5) {
      return false;
    }
    if (email.indexOf("@") === -1) {
      return false;
    }
    if (email.indexOf(".") === -1) {
      return false;
    }
    return true;
  }

  const fillDataFromContact = (contact) => {
    setEntreprise(contact.name);
    setPrenom(contact.prenom);
    setEmail(contact.email);
    setPhone(contact.mobile);
    setVille(contact.city);
    setPostal(contact.postal);
    setAdresse(contact.address);
  };

  const [loadingData2, setLoadingData2] = useState(false);

  const [new_partner_user_id, setNew_partner_id] = useState("");
  const [new_partner_org_id, setNew_partner_org_id] = useState("");
  const [invite_open, setInviteOpen] = useState(false);
  useEffect(() => {
    if (currentUser) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [currentUser]); // Dependency array ensures this runs when currentUser changes

  const useSuggestedValue = (value) => {
    // find the contact in the contacts array that has the same value as the value passed in
    // set the value of the contact to the value of the key "label"
    const found = contacts.find((contact) => contact.name === value.label);
    if (found) {
      fillDataFromContact(found);
    }
  };

  const [citiesName, setCitiesName] = useState([]);
  const [postalCodes, setPostalCodes] = useState([]);
  const [loadingSearch, setLoadingSearch] = useState(false);

  const fetchPostalCodes = async (city, exact_match = false) => {
    await fetchPostalCodesApi(
      setCitiesName,
      setPostalCodes,
      setPostal,
      setLoadingSearch,
      prefix,
      city,
      exact_match,
      postal
    );
  };

  const handlesendInvite = async () => {
    const token = await getOrRefreshFirebaseToken(); // Fetch Firebase token
    let new_user = await getUserById(new_partner_user_id);
    let org = await getOrgDataById(new_user.org_id);
    if (org.invite !== "accepted") {
      await updateDocDataFieldApi(org.ref, "invite", "sent", prefix);
    }
    await sendInvite(
      new_partner_user_id,
      orgData.name,
      new_user.email,
      org.id,
      token,
      prefix
    ); // Call the sendInvite API
    handleClickVariant("Invitation envoyée avec succès", "success");
    navigateWorkspace("/partner/" + org.id);
  };

  // Function to create a new client
  const createPartner = async () => {
    if (!userData || !orgData) return;

    try {
      if (email === "") {
        handleClickVariant("Veuillez saisir l'adresse email", "error");
        return;
      }
      if (!checkEmail(email)) {
        handleClickVariant("Veuillez saisir une adresse email valide", "error");
        return;
      }

      const filters = [
        {
          field: "email",
          operator: "==",
          value: email,
        },
      ];

      const doublons = (await queryCollection("user", filters)) || [];
      if (doublons.length > 0) {
        const my_network_filters = [
          {
            field: "email",
            operator: "==",
            value: email,
          },
          {
            field: "masters_id",
            operator: "array-contains",
            value: orgData.id,
          },
        ];

        const doublons_in_network =
          (await queryCollection("org", my_network_filters)) || [];
        if (doublons_in_network.length > 0) {
          handleClickVariant(
            "Un utilisateur avec cet email existe déjà dans votre réseau",
            "error"
          );
          return;
        } else {
          // add already existing client to the network
          let partner = await getOrgDataById(doublons[0].org_id);
          if (partner.email === "william.bresso@gmail.com") {
            handleClickVariant(
              "Vous ne pouvez pas ajouter ce partenaire",
              "error"
            );
            setEmail("");
            setPartnerOpen(false);
            setParnterExists(null);
            return;
          }

          let masters_id = partner.masters_id || [];
          masters_id.push(orgData.id);
          await updateDocDataFieldApi(
            partner.ref,
            "masters_id",
            masters_id,
            prefix
          );

          let workspace_body = {
            master_id: orgData.id,
            master_name: orgData.name,
            partner_id: partner.id,
            accesses: {},
            affiliated_partners_id: [],
            commercial_infos: {},
            permissions: {
              admin_folders: false,
              new_estimates:
                orgData.partner_type != "expert" &&
                orgData.partner_type != "infiltro",
              new_folders:
                orgData.partner_type != "expert" &&
                orgData.partner_type != "infiltro",
              payment_allowed: ![
                "expert",
                "infiltro",
                "promotor",
                "constructor",
                "other",
              ].includes(orgData.partner_type),
            },
          };
          let new_workspace = await createDocApi(
            "workspace",
            workspace_body,
            prefix
          );

          let workspaces_id = partner.workspaces_id || [];
          workspaces_id.push(new_workspace.id);

          await updateDocDataFieldApi(
            partner.ref,
            "workspaces_id",
            workspaces_id,
            prefix
          );

          handleClickVariant(
            "Un utilisateur avec cet email existe déjà dans la base de données. Il a été ajouté à votre réseau",
            "success"
          );
          Gleap.trackEvent("Client created", {
            userId: userData.id,
          });
          navigateWorkspace("/partner/" + partner.id);
        }

        return;
      }
      if (!partner_type) {
        handleClickVariant("Veuillez sélectionner la catégorie", "error");
        return;
      }

      if (entreprise === "") {
        handleClickVariant("Veuillez saisir le nom de l'entreprise", "error");
        return;
      }
      if (prenom === "") {
        handleClickVariant("Veuillez saisir le prénom", "error");
        return;
      }
      if (phone === "") {
        handleClickVariant("Veuillez saisir le numéro de téléphone", "error");
        return;
      }
      if (ville === "") {
        handleClickVariant("Veuillez saisir la ville", "error");
        return;
      }
      if (postal === "") {
        handleClickVariant("Veuillez saisir le code postal", "error");
        return;
      }

      setLoadingData(true); // Set loading state to true
      const oid = orgData.id; // Assuming orgData has the organization id

      // Get the user's Firebase authentication token
      const token = await currentUser.getIdToken(); // Fetch token from Firebase
      const new_user_id = await createNewPartner(
        phone.trim(), // Phone number
        email.trim(), // Email address
        ville.trim(), // City
        postal.trim(), // Postal code

        entreprise.trim(), // Company name
        partner_type, // Client type
        payment_allowed,
        adresse.trim(), // Address
        oid, // Organization ID
        token, // Firebase Authentication token
        prenom,
        siren.trim(), // SIREN number
        prefix
      );

      let new_user = await getUserById(new_user_id);
      let org = await getOrgDataById(new_user.org_id);

      await checkAndSendTriggerEvent(
        ["first_partner_created"],
        orgData,
        userData,
        prefix
      );
      setLoadingData(false); // Set loading state to false
      setInviteOpen(true); // Close the dialog

      setNew_partner_id(new_user.id);
      setNew_partner_org_id(org.id);
      handleClickVariant("Partenaire créé avec succès", "success");
    } catch (error) {
      console.error("Error creating partner:", error);
    }
  };

  if (loading || !currentUser || !userData) {
    return (
      <div className="h-full w-c400 pl-4 flex flex-col gap-2">
        <Space y={20} />
        <Skeleton variant="rounded" width={200} height={25} />
        <Divider orientation="horizontal" />
        <Space y={10} />
        <div align="left" className="w-full pr-2 flex flex-col" y={10}>
          {/* Skeletons for text fields */}
          <Skeleton variant="rounded" width="100%" height={30} />
          <Space y={10} />
          <Skeleton variant="rounded" width="100%" height={30} />
          <Space y={10} />
          <Skeleton variant="rounded" width="100%" height={30} />
          <Space y={10} />

          {/* Skeletons for DatePicker and TimePicker */}
          <Skeleton variant="rounded" width="100%" height={30} />
          <Space y={10} />
          <Skeleton variant="rounded" width="100%" height={30} />
          <Space y={10} />

          {/* Skeleton for dropdowns */}
          <Skeleton variant="rounded" width="100%" height={30} />
          <Space y={10} />
          <Skeleton variant="rounded" width="100%" height={30} />
        </div>

        <Space y={10} />

        {/* Skeleton for button */}
        <div className="w-full flex flex-row-reverse">
          <Skeleton variant="rectangular" width={120} height={40} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex-row w-full h-full overflow-auto flex gap-10 pb-20">
      <Modal1
        isOpen={invite_open}
        onClose={() => {
          setInviteOpen(false);
          navigateWorkspace("/partners");
        }}
      >
        {" "}
        <div className="bg-white flex flex-col p-4 w-c300 rounded-3xl  ">
          <div className="flex flex-col gap-3 w-full">
            <div className="flex flex-row justify-between">
              {" "}
              <div className="text-h3 text-shadow_50">
                Envoyer une invitation au client par email pour se connecter sur
                son espace
              </div>
            </div>
            <div className="flex flex-row gap-2 justify-between">
              <SecondaryButton
                className="w-full"
                onClick={() => {
                  setInviteOpen(false);
                  navigateWorkspace("/partner/" + new_partner_org_id);
                }}
              >
                Passer
              </SecondaryButton>{" "}
              <PrimaryButton className="w-full" onClick={handlesendInvite}>
                Envoyer
              </PrimaryButton>
            </div>
          </div>
        </div>
      </Modal1>
      <Modal1
        isOpen={partner_open}
        onClose={() => {
          setPartnerOpen(false);
        }}
      >
        {" "}
        <div className="bg-white flex flex-col p-4 w-c500 rounded-3xl  ">
          <div className="flex flex-col gap-3 w-full">
            <div className="flex flex-col ">
              {" "}
              <div className="text-h3 text-black">
                Cette entreprise existe déjà dans notre base de données
              </div>
              <div className="flex flex-row gap-4 my-4  rounded-lg p-2 bg-neutral-50 border-1 border-shadow_25">
                <div className="text-h3 text-shadow_50">
                  <img
                    src={partner_exists?.logo}
                    className="w-16 h-16 rounded-lg object-contain"
                  ></img>
                </div>{" "}
                <div className="flex flex-col">
                  <div className="text-h3 text-shadow_50">
                    {partner_exists?.name}
                  </div>
                  <div className="text-h3 text-shadow_50">
                    {partner_exists?.email}
                  </div>
                  <div className="text-h3 text-shadow_50">
                    {partner_exists?.infos?.ville}
                  </div>
                  <div className="text-h3 text-shadow_50">
                    {partner_exists?.infos?.postal}
                  </div>{" "}
                  <div className="text-h3 text-shadow_50">
                    {partner_exists?.infos?.phone}
                  </div>{" "}
                </div>
              </div>
              <div className="text-h3 text-shadow_50">
                Si l'entreprise correspond au partenaire que vous souhaitez
                ajouter, ajoutez le dirctement à votre réseau.
              </div>
            </div>
            <div className="flex flex-row gap-2 justify-end">
              <PrimaryButton onClick={createPartner} disabled={loadingData}>
                <div className="flex flex-row content-center align-middle items-center">
                  Ajouter le partenaire <Space x={5} />
                  <SmallSpinner loading={loadingData} margin={0} size={20} />
                </div>
              </PrimaryButton>
            </div>
          </div>
        </div>
      </Modal1>
      {/* Left Column: Takes all available space */}
      {/* Right Column: Fixed width */}
      <div className="h-fit flex  flex-col max-w-c500 pl-4 pb-20">
        <div className="text-h1 font-semibold">Nouveau partenaire</div>
        <Space y={20} />
        <div className="text-h3 text-shadow_50">
          Cette interface permet d'ajouter des partenaires mais n'est pas
          pertinente pour inviter des particuliers.
        </div>{" "}
        <Space y={5} />
        <div className="text-h3 text-shadow_50">
          Si vous voulez inviter des particuliers, utilisez l'interface de
          création de dossier et sélectionner "Client particulier".
        </div>
        <Space y={20} />
        <div className={"flex flex-col h-fit gap-2  pr-2"}>
          <TextField2T
            label="Email"
            value={email}
            type="email"
            mandatory={true}
            onChange={(e) => {
              setEmail(e.target.value);
              handleCheckEmailExists(e.target.value);
            }}
          ></TextField2T>
          <div className={"flex flex-row gap-2 h-fit w-full pr-2"}>
            <DropDownGPT03
              items={type_options}
              className="w-full"
              label="Catégorie"
              value={partner_type} // Controlled component
              mandatory={true}
              onChange={(e) => setPartnerType(e.value)} // Update state on change
            ></DropDownGPT03>{" "}
          </div>
          <TextField2T
            className="w-full"
            label="Entreprise"
            value={entreprise}
            mandatory={true}
            items={contacts.map(
              (
                contact // map a dict wit hvalue, label
              ) => ({ value: contact.name, label: contact.name })
            )}
            onChange={(e) => setEntreprise(e.target.value)}
            useSuggestedValue={useSuggestedValue}
          ></TextField2T>
          <TextField2T
            className="w-full"
            label="SIREN"
            type="siren"
            value={siren}
            mandatory={false}
            onChange={(e) => setSiren(e.target.value)}
          ></TextField2T>
          <TextField2T
            className="w-full"
            label="Prénom Nom"
            value={prenom}
            onChange={(e) => setPrenom(e.target.value)}
            mandatory={true}
          ></TextField2T>
          <TextField2T
            label="Téléphone"
            value={phone}
            type="phone"
            mandatory={true}
            onChange={(e) => setPhone(e.target.value)}
          ></TextField2T>
          <DropDownGPTS3
            label="Ville"
            value={ville}
            mandatory={true}
            onChange={(e) => {
              setVille(e.value);
              fetchPostalCodes(e.value, true);
            }}
            active_filter_inculdes={false}
            onSearchChange={(value) => {
              fetchPostalCodes(value);
            }}
            debounceDelay={500}
            loadingSearch={loadingSearch}
            transparent={false}
            items={citiesName.map((city) => ({
              value: city,
              label: city,
            }))}
          ></DropDownGPTS3>
          <DropDownGPTS3
            label="Code Postal"
            value={postal}
            disabled={citiesName.length === 0}
            loadingSearch={loadingSearch}
            mandatory={true}
            onChange={(e) => setPostal(e.value || "")}
            transparent={false}
            items={postalCodes.map((code) => ({
              value: code,
              label: code,
            }))}
          ></DropDownGPTS3>{" "}
          <TextField2T
            label="Adresse"
            value={adresse}
            mandatory={true}
            onChange={(e) => setAdresse(e.target.value)}
          ></TextField2T>
          {!["infiltro", "expert"].includes(partner_type) && (
            <ToggleSettingsBrick
              title="Utiliser le paiement particulier pour ce client"
              description={
                "Si activé, il sera possible de créer des paiements dans les dossiers de ce client et les rapports lui seront débloqués automatiquement lorsque le particulier paye."
              }
              checked={payment_allowed}
              onChange={(checked) => {
                setPaymentAllowed(checked);
              }}
            ></ToggleSettingsBrick>
          )}
        </div>
        <Space y={20} />
        <div className="w-full flex flex-row justify-end">
          <PrimaryButton onClick={createPartner} disabled={loadingData}>
            <div className="flex flex-row content-center align-middle items-center">
              Créer le partenaire <Space x={5} />
              <SmallSpinner loading={loadingData} margin={0} size={20} />
            </div>
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
}

export default NewPartner;
